import React from 'react';
import PropTypes from 'prop-types';
import { resolveRenderField } from '../../../../../services/cms/HtmlResolver';

export const DisclaimerSection = ({ disclaimerContent, cmsTags }) => {
  return (
    <div className="disclaimerSection">
      {disclaimerContent?.map(({ fullKey, field }) => (
        <React.Fragment key={fullKey}>{resolveRenderField({ field, key: fullKey, cmsTags })}</React.Fragment>
      ))}
    </div>
  );
};

DisclaimerSection.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  disclaimerContent: PropTypes.array,
  cmsTags: PropTypes.object
  /* eslint-disable react/forbid-prop-types */
};
